import { Search } from '../search'
import { UserNav } from './user-nav'
import { Button } from '../custom/button'
import { IconMenu2, IconX } from '@tabler/icons-react'
import { useEffect } from 'react'
import { loadLocalState } from '@/utils/storage'
import useChangeLanguage from '@/hooks/use-change-language'

interface HeaderProps {
  navOpened: boolean
  onToggleNav: () => void
}

const Header = ({ navOpened, onToggleNav }: HeaderProps) => {
  const handleChangeLanguage = useChangeLanguage()

  useEffect(() => {
    handleChangeLanguage(loadLocalState('lang') ?? 'en')
    return () => handleChangeLanguage(loadLocalState('lang') ?? 'en')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <header
      data-layout='header'
      className='sticky z-10 mt-16 flex h-12 items-center gap-3 border-b-muted bg-background px-2.5 shadow dark:border-b-2 sm:px-4 md:mt-0 md:h-[var(--header-height)] md:gap-4 md:px-8'
    >
      <div className='flex min-w-0 flex-1 items-center justify-end gap-2 md:gap-4'>
        <Button
          variant='ghost'
          size='icon'
          className='md:hidden'
          aria-label='Toggle Navigation'
          aria-controls='sidebar-menu'
          aria-expanded={navOpened}
          onClick={onToggleNav}
        >
          {navOpened ? <IconX /> : <IconMenu2 />}
        </Button>
        <div className='min-w-0 flex-1 md:flex-none'>
          <Search />
        </div>
        <div className='hidden md:block'>
          <UserNav />
        </div>
      </div>
    </header>
  )
}

export default Header
